import React from 'react';

import {RunQueryContext} from '../../state/runs/context';
import {useInitializeRampFlagsStores} from '../../util/rampFeatureFlags/stores/useInitRampFlagsStore';
import {LoaderProxy} from './../../containers/AppLoader';
// oxlint-disable-next-line import/no-cycle -- please fix if you can
import {MultiRunWorkspaceWorkspace} from './../MultiRunWorkspace';
import NoMatch from './../NoMatch';
import {type MultiRunWorkspaceProps} from './types';
import {useMultiRunWorkspaceQueryProps} from './useMultiRunWorkspaceQueryProps';

export const MultiRunWorkspaceWithContext = (props: MultiRunWorkspaceProps) => {
  const {entityName, projectName, runsQueryContextValue} = props;
  const multiRunWorkspaceProps = useMultiRunWorkspaceQueryProps(props);

  // Hydrates ramp-flag stores for every multi-run workspace (project, sweep,
  // group). Uses the same `entityName` as `RunQueryContext` below so flags
  // resolve against the page's entity. Reports mount their own init in
  // `ReportPageContainer.tsx`.
  useInitializeRampFlagsStores();

  const value = React.useMemo(() => {
    return {
      entityName,
      projectName,
      mergeFilters: props.mergeFilters,
      runSetName: props.runSetName,
      ...runsQueryContextValue,
    };
  }, [
    entityName,
    projectName,
    runsQueryContextValue,
    props.mergeFilters,
    props.runSetName,
  ]);

  if (multiRunWorkspaceProps.loading) {
    return <LoaderProxy name="multi-run-workspace-loader" />;
  }
  if (multiRunWorkspaceProps.error) {
    return <NoMatch />;
  }

  return (
    <RunQueryContext.Provider value={value}>
      <MultiRunWorkspaceWorkspace
        {...props}
        {...multiRunWorkspaceProps.readyProps}
      />
    </RunQueryContext.Provider>
  );
};
